// extracted by mini-css-extract-plugin
module.exports = {"logo":"MainLayout_logo__1f0T2","trigger":"MainLayout_trigger__2W8A_","navScroll":"MainLayout_navScroll__2af_h","nav":"MainLayout_nav__Kvf96"};